import axios from 'axios';

/* Shop and warehouse names by id, for showing a saved record's party (2026-11-02). Some records
 * store a shop's id rather than its name (e.g. a shop-to-shop device sale). Loaded once per page
 * and cached; on any failure the id itself is shown. Ids are compared as text. */
let shopNames = null;
let warehouseNames = null;

function load(url, idKey, nameKey, method = 'get') {
    return axios[method](`${process.env.REACT_APP_BASE_URL}${url}`)
        .then(res => {
            const map = new Map();
            if (res.data && res.data.success === 1) {
                for (const row of res.data.data) map.set(String(row[idKey]), row[nameKey]);
            }
            return map;
        })
        .catch(() => new Map());
}

export function shopName(id) {
    if (!shopNames) shopNames = load('services/query/PCGetShops.php', 'PC_SP_ID', 'SP_NAME');
    return shopNames.then(m => m.get(String(id)) || String(id || ''));
}

export function warehouseName(id) {
    if (!warehouseNames) warehouseNames = load('services/query/PCGetAllWarehouse.php', 'WAREHOUSE_ID', 'WAREHOUSE_NAME');
    return warehouseNames.then(m => m.get(String(id)) || String(id || ''));
}
